// FE-08 (2026-10-05). Account entry behaviour. Markup: snippets/bge-account-panel.liquid
// (desktop panel) and snippets/login-form.liquid (phone drawer, opened by theme.js).
// Desktop: the trigger is a link (works with no JS); here it becomes a disclosure button.
// Click toggles, never hover. Opening moves focus to the first control in the panel; Escape,
// an outside click, tabbing out, scrolling the bar away or the mega menu opening close it.
// Escape returns focus to the trigger. Phones: the account drawer is a modal dialog while
// open (see initDrawer). Vanilla, no jQuery.
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 1025px)');

  function initPanel() {
    var root = document.querySelector('[data-bge-acct]');
    if (!root) return;
    var trigger = root.querySelector('[data-bge-acct-trigger]');
    var panel = root.querySelector('[data-bge-acct-panel]');
    if (!trigger || !panel) return;

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-expanded', 'false');

    function isOpen() { return !panel.hidden; }
    function open(focusFirst) {
      if (isOpen()) return;
      panel.hidden = false;
      panel.classList.remove('is-opening');
      void panel.offsetWidth; // restart the open animation
      panel.classList.add('is-opening');
      trigger.setAttribute('aria-expanded', 'true');
      if (focusFirst) {
        var first = panel.querySelector('a[href], button:not([disabled])');
        if (first) first.focus();
      }
    }
    function close(returnFocus) {
      if (!isOpen()) return;
      // focus inside the panel would drop to <body> when it hides: hand it to the trigger
      if (panel.contains(document.activeElement)) returnFocus = true;
      panel.hidden = true;
      panel.classList.remove('is-opening');
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    }

    trigger.addEventListener('click', function (e) {
      if (!DESKTOP.matches) return; // phones and tablets follow the link
      e.preventDefault();
      if (isOpen()) close(false);
      else open(true);
    });
    // role=button: Space activates it like a button (Enter already fires click on a link)
    trigger.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); trigger.click(); }
    });
    // on document, not the panel: a click on the panel's text moves focus to <body>
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { e.preventDefault(); close(true); }
    });
    root.addEventListener('focusout', function (e) {
      if (isOpen() && e.relatedTarget && !root.contains(e.relatedTarget)) close(false);
    });
    document.addEventListener('click', function (e) {
      if (isOpen() && !root.contains(e.target)) close(false);
    });
    window.addEventListener('scroll', function () {
      if (isOpen() && trigger.getBoundingClientRect().bottom < 0) close(false);
    }, { passive: true });
    DESKTOP.addEventListener('change', function () { close(false); });

    // The mega menu marks its root .has-open while a panel shows: close ours then.
    var mega = document.querySelector('[data-bgv2-mega]');
    if (mega && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (mega.classList.contains('has-open')) close(false);
      }).observe(mega, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // Phone drawer (#login-mobile, body.open_Account toggled by theme.js by toggle, close button
  // and scrim). Whatever opens or closes it, a class observer on <body> applies the dialog
  // semantics: role=dialog + aria-modal + label while open, Tab and Shift+Tab wrap inside,
  // page scroll locked, focus to Sign in on open and back to the toggle on close. Closed, the
  // off-screen drawer is inert so Tab never walks into it. Scoped to #login-mobile: the vendor
  // menu drawer shares the shell class.
  function initDrawer() {
    var toggle = document.querySelector('[data-login-toggle]');
    var shell = document.getElementById('login-mobile');
    if (!toggle || !shell) return;
    var body = document.body;
    var html = document.documentElement;
    var wasOpen = false, prevOverflow = '';
    toggle.setAttribute('aria-expanded', 'false');
    shell.inert = true;

    function focusables() {
      return Array.prototype.filter.call(
        shell.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.getClientRects().length > 0; }
      );
    }
    function onOpen() {
      shell.inert = false;
      shell.setAttribute('role', 'dialog');
      shell.setAttribute('aria-modal', 'true');
      if (document.getElementById('login-dropdown-title')) shell.setAttribute('aria-labelledby', 'login-dropdown-title');
      else shell.setAttribute('aria-label', 'Sign in');
      toggle.setAttribute('aria-expanded', 'true');
      prevOverflow = html.style.overflow;
      html.style.overflow = 'hidden';
      setTimeout(function () {
        var first = shell.querySelector('#login-dropdown .bge-acct__btn') || focusables()[0];
        if (first) first.focus({ preventScroll: true });
      }, 50);
    }
    function onClose() {
      var a = document.activeElement;
      var hadFocus = !a || a === body || shell.contains(a);
      shell.removeAttribute('role');
      shell.removeAttribute('aria-modal');
      shell.removeAttribute('aria-labelledby');
      shell.removeAttribute('aria-label');
      shell.inert = true;
      toggle.setAttribute('aria-expanded', 'false');
      html.style.overflow = prevOverflow;
      if (hadFocus) toggle.focus({ preventScroll: true });
    }
    function check() {
      var on = body.classList.contains('open_Account');
      if (on === wasOpen) return;
      wasOpen = on;
      if (on) onOpen(); else onClose();
    }
    new MutationObserver(check).observe(body, { attributes: true, attributeFilter: ['class'] });

    // The toggle is a real link to the hosted login (the no-JS path); theme.js opens the drawer
    // on click but does not stop the link, so stop it here.
    toggle.addEventListener('click', function (e) { e.preventDefault(); });
    document.addEventListener('keydown', function (e) {
      if (!wasOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); body.classList.remove('open_Account'); return; }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1], a = document.activeElement;
      if (!shell.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });
  }

  function init() { initPanel(); initDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
